// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type CancelExportMutationVariables = Types.Exact<{
  executionId: Types.Scalars['String']['input'];
}>;

export type CancelExportMutation = { cancelExport: { executionId: number } };

export const CancelExportDocument = gql`
    mutation CancelExport($executionId: String!) {
  cancelExport(executionId: $executionId) {
    executionId
  }
}
    ` as unknown as DocumentNode<CancelExportMutation, CancelExportMutationVariables>;
